import React from 'react';
import { LayoutGrid, Wrench } from 'lucide-react';

/**
 * Two-position toggle that lets a staff member flip between their own work
 * panel and a read-only overview of every live order. Persists the choice in
 * localStorage so the next session opens in the same mode.
 *
 * Props:
 *   value: 'mine' | 'all'
 *   onChange: (next: 'mine'|'all') => void
 */
export default function PanelViewToggle({ value, onChange }) {
  return (
    <div className="inline-flex items-center bg-white/5 border border-white/10 rounded-sm p-0.5" data-testid="panel-view-toggle">
      <button
        type="button"
        onClick={() => onChange('mine')}
        className={`px-2.5 py-1 rounded-sm font-sans text-[11px] uppercase tracking-[0.15em] font-semibold flex items-center gap-1.5 transition-colors ${
          value === 'mine'
            ? 'bg-gold/20 text-gold border border-gold/30'
            : 'text-zinc-400 hover:text-zinc-200 border border-transparent'
        }`}
        data-testid="panel-view-mine"
        aria-pressed={value === 'mine'}
      >
        <Wrench className="w-3 h-3" /> My Panel
      </button>
      <button
        type="button"
        onClick={() => onChange('all')}
        className={`px-2.5 py-1 rounded-sm font-sans text-[11px] uppercase tracking-[0.15em] font-semibold flex items-center gap-1.5 transition-colors ${
          value === 'all'
            ? 'bg-blue-accent/20 text-blue-accent border border-blue-accent/30'
            : 'text-zinc-400 hover:text-zinc-200 border border-transparent'
        }`}
        data-testid="panel-view-all"
        aria-pressed={value === 'all'}
      >
        <LayoutGrid className="w-3 h-3" /> All Orders
      </button>
    </div>
  );
}
